import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { Message } from '../../models/message.model';
import { CompanyCategories } from '../../models/company.categories.model';
import { Company } from '../../models/company.model';
import { Category } from '../../models/category.model';
import { Service } from '../../models/service.model';
import { Product } from '../../models/product.model';
import { authToken } from '../../scripts/authentication.script';

export class CategoryDA {
  static apiResponse: ApiResponse

  public static async getCategories(
    id_company: string,
    category_name: string,
    sort_field: string,
    sort_mode: string,
    page: number = 1,
    limit: number = 20
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let companyCategories: CompanyCategories | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/categories.data.json').then(response => { companyCategories = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (companyCategories!.id_company === id_company) {
        companyCategories!.filter = { name: category_name, sort_field: sort_field, sort_mode: sort_mode }

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: companyCategories
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories?name=${category_name}&sort_field=${sort_field}&sort_mode=${sort_mode}&page=${page}&limit=${limit}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async getCategory(
    id_company: string,
    id_category: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let category: Category | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/category.data.json').then(response => { category = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (category!.id === id_category) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: category
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories/${id_category}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async postCategory(
    id_company: string,
    display_name: string,
    description: string,
    names: { en: string, fr: string, it: string, de: string },
    accounts: { expense: string, vat: string, income: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let company: Company | null = null
      let category: Category | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/company.data.json').then(response => { company = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (company!.id === id_company) {
        category = {
          id: `category${(Math.floor(Math.random() * 1000)).toString()}`,
          display_name: display_name,
          description: description,
          names: names,
          accounts: accounts,
          services: [],
          products: []
        }

        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: category
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        display_name: display_name,
        description: description,
        names: names,
        accounts: accounts
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async putCategory(
    id_company: string,
    id_category: string,
    display_name: string,
    description: string,
    names: { en: string, fr: string, it: string, de: string },
    accounts: { expense: string, vat: string, income: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let category: Category | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/category.data.json').then(response => { category = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (category!.id === id_category) {
        category!.display_name = display_name
        category!.description = description
        category!.names = names
        category!.accounts = accounts

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: category
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories/${id_category}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        display_name: display_name,
        description: description,
        names: names,
        accounts: accounts
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async putCategoryProducts(
    id_company: string,
    id_category: string,
    id_services: string[],
    id_products: string[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let services: Service[] | null = null
      let products: Product[] | null = null
      let category: Category | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/services.data.json').then(response => { services = response.data.services }).catch(error => { alert(error) })
      await axios.get('../../../../../database/products.data.json').then(response => { products = response.data.products }).catch(error => { alert(error) })
      await axios.get('../../../../../database/category.data.json').then(response => { category = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (category!.id === id_category) {
        category!.services = services!.filter(item => id_services.includes(item.id))
        category!.products = products!.filter(item => id_products.includes(item.id))

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: category
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories/${id_category}/listing`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        services: id_services,
        products: id_products
      }

      await axios.put(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }

  public static async deleteCategories(
    id_company: string,
    id_categories: string[]
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let categories: Category[] | null = null
      let message: Message | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/categories.data.json').then(response => { categories = response.data.categories }).catch(error => { alert(error) })
      await axios.get('../../../../../database/message.data.json').then(response => { message = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (categories!.some(item => id_categories.includes(item.id))) {
        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: message
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/categories`

      let config: any = {
        headers: { Authorization: authToken() },
        data: { categories: id_categories }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Unknown error',
          data: error.response?.data?.error ?? error.message
        }
      })
    }

    return this.apiResponse
  }
}
